import { Outlet, NavLink, useLocation, matchPath } from "react-router-dom";
import Image from "react-bootstrap/Image";
import PublicNav from "../components/navigation/PublicNav";
import PodcasterNav from "../components/navigation/PodcasterNav";
import ListenerNav from "../components/navigation/ListenerNav";
import AdminNav from "../components/navigation/AdminNav";

export default function TopNavLayout() {
    const { pathname } = useLocation();

    // '/' renders its own header (see Home.js) to match the redesigned landing page
    const publicNavRoutePaths = ['/corporate', '/join'];
    const regNavRoutePaths = ['/login', '/signup', '/register'];
    const listenerNavRoutePaths = [
        '/listener-dashboard',
        '/listener-clubs',
        '/portfolio',
        '/profile',
        '/listener-podcast-club/:guid',
        '/listener-podcast-club/:guid/discussion/:discussionGuid',
        '/listener-episode/:podcastClubId/:episodeId',
        '/listener-podcaster/:guid',
        '/listener-practices'
    ];
    const podcasterNavRoutePaths = [
        '/podcaster-dashboard',
        '/podcaster/profile',
        '/podcaster/podcast-club/:guid',
        '/podcaster/podcast-club/:guid/discussion/:discussionGuid',
        '/resources',
        '/admin',
    ];
    const isUserAdmin = false;

    const isInPaths = (paths) => paths.some(path => matchPath(path, pathname));

    return (
        <div className="d-flex flex-column">
            {isUserAdmin && <AdminNav />}
            {isInPaths(publicNavRoutePaths) && <PublicNav />}
            {isInPaths(podcasterNavRoutePaths) && <PodcasterNav />}
            {isInPaths(listenerNavRoutePaths) && <ListenerNav />}
            <main className="">
                <Outlet />
            </main>
        </div>
    );
}
